// Auto-generated version file
// Updated on each build with timestamp and git commit info

export const VERSION = {
  // Build information
  buildNumber: process.env.REACT_APP_BUILD_NUMBER || 'dev',
  buildDate: process.env.REACT_APP_BUILD_DATE || new Date().toISOString(),
  gitCommit: process.env.REACT_APP_GIT_COMMIT || 'unknown',
  gitBranch: process.env.REACT_APP_GIT_BRANCH || 'unknown',

  // Semantic version
  version: process.env.REACT_APP_VERSION || '1.0.0',

  // Environment
  environment: process.env.NODE_ENV || 'development',
};

// Helper to get formatted version string
export const getVersionString = () => {
  if (VERSION.environment === 'development') {
    return `v${VERSION.version}-dev`;
  }
  return `v${VERSION.version} (${VERSION.buildNumber})`;
};

// Helper to get backend API version
export const getBackendVersion = async () => {
  try {
    const baseUrl = process.env.REACT_APP_API_BASE_URL;
    const response = await fetch(`${baseUrl}/version`);
    if (response.ok) {
      return await response.json();
    }
  } catch (error) {
    console.debug('Backend version check failed:', error.message);
  }
  return null;
};

export default VERSION;
